import React from "react";
import { Box, Button, Card, Grid, makeStyles } from "@material-ui/core";
import SubjectPropertyInformationCardHeader from "./subjectPropertyInformationCardHeader";
import { PicturesCarousel } from "./picturesCarousel";
import { PropertyInformationForm } from "./propertyInformationForm";
import { PropertyStatusInformation } from "./propertyStatusInformation";
import { observer } from "mobx-react";
import { InternalValuationReviewStore } from "../stores/internalValuationReviewStore";
import { Document } from "@roc/feature-types";
import { useDocumentStore, WithDocumentActions } from "@roc/feature-documents";
import { CloudDownload } from "@material-ui/icons";
import SaveOutlinedIcon from '@material-ui/icons/SaveOutlined';

interface SubjectPropertyInformationCardProps {
  internalValuationReviewStore: InternalValuationReviewStore;
  generateReport: () => void;
  document?: Document;
}

const useStyles = makeStyles(() => ({
  subjectPropertyInfoCard: {
    height: "500px",
    padding: "10px",
  },
  iconBox: {
    backgroundColor: "#E4E8EB",
    borderRadius: "100%",
    width: "2.5rem",
    height: "2.5rem",
  },
  button: {
    minWidth: "185px",
  }
}));

export const SubjectPropertyInformationCard = observer(({ internalValuationReviewStore, generateReport, document }: SubjectPropertyInformationCardProps) => {
  const classes = useStyles();
  const { propertyInformationFormStore, propertyStatusInformationStore } = internalValuationReviewStore.subjectPropertyInformationStore;
  const { propertyCompFormStores } = internalValuationReviewStore;
  const { documentStore } = useDocumentStore();

  const readOnly = internalValuationReviewStore.readOnly;

  const saveHandler = () => {
    internalValuationReviewStore.saveInternalValuationReview();
  }

  const generateReportHandler = () => {
    generateReport();
  }

  const downloadAppraisalReportHandler = () => {
    internalValuationReviewStore.downloadAppraisalReport();
  }

  const onDownloadReport = () => {
    documentStore.downloadDocument(document!);
  }

  return (
    <Card style={{ border: "1px solid #BABEC5", borderRadius: "14px" }}>
      <Box padding={2}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SubjectPropertyInformationCardHeader internalValuationReviewStore={internalValuationReviewStore} generateReport={generateReport} document={document} />
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={5}>
                <PicturesCarousel propertyInformationFormStore={propertyInformationFormStore} />
              </Grid>
              <Grid item xs={7}>
                <PropertyInformationForm propertyInformationFormStore={propertyInformationFormStore} readOnly={readOnly} propertyCompFormStores={propertyCompFormStores} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" flexDirection="row" gridGap="1rem" justifyContent="flex-end" margin="16px 0">
              {document?.canDownloadFile && (
                <Button className={classes.button} variant="contained" color="primary" onClick={onDownloadReport} endIcon={<CloudDownload />}>
                  Download Report
                </Button>
              )}
              <Button className={classes.button} variant="contained" color="primary" onClick={downloadAppraisalReportHandler}>
                Appraisal Report
              </Button>
              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                onClick={generateReportHandler}
                disabled={readOnly}
              >
                Generate Report
              </Button>
              <WithDocumentActions
                component={Button}
                document={document!}
                disabled={readOnly}
                variant="outlined"
                color="primary"
                startIcon={<SaveOutlinedIcon />}
                onClick={saveHandler}
              >
                Save
              </WithDocumentActions>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <PropertyStatusInformation propertyStatusInformationStore={propertyStatusInformationStore} />
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
});
